import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { DateTimePicker } from 'react-tempusdominus-bootstrap'
import { TicketTable } from './TicketTable'
import CreateTicketModal from './CreateTicketModal'
import { TicketDetailsModal } from './TicketDetailModal'
import {
  createUserTicketAsync,
  getAllUserTicketsAsync,
  SupportTicketAction,
  getUserTicketDetailsAsync,
  addTicketCommentAsync,
} from '../_redux'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Table, Modal, Toast } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { userProfileInfoAsync } from '../../Auth/_redux'

function SupportTicket() {
  const [OrderDetailsModal, setOrderDetailsModalModal] = useState(false)
  const handleClose = () => setOrderDetailsModalModal(false)
  const handleShow = () => setOrderDetailsModalModal(true)

  const [status, setStatus] = useState('')
  ////
  const {
    ticketList,
    isLoading,
    refreshList,
    openTicketDetailsModal,
    selectedTicket,
    skip,
    limit,
  } = useSelector((state) => state.supportTicket, shallowEqual)
  const user = useSelector((state) => state.auth.user, shallowEqual)

  const handleClose1 = () =>
    dispatch(SupportTicketAction.toggleTicketDetailModal(false))
  const handleShow1 = (ticket) => {
    dispatch(getUserTicketDetailsAsync(user._id, ticket._id))
  }

  const dispatch = useDispatch()

  useEffect(() => {
    if (refreshList) {
      dispatch(getAllUserTicketsAsync(user._id, status))
    }
  }, [refreshList])

  useEffect(() => {
    dispatch(userProfileInfoAsync(user._id))
  }, [])

  const onCreateTicketSubmit = (data) => {
    dispatch(createUserTicketAsync(data, user._id))
    handleClose()
  }

  const onAddComment = (comment) => {
    dispatch(addTicketCommentAsync(comment, user._id, selectedTicket._id))
  }

  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip
    dispatch(SupportTicketAction.setTicketBatchNumber(count))
  }

  const onStatusChange = (e) => {
    let status = e.target.value
    setStatus(status)
    dispatch(getAllUserTicketsAsync(user._id, status))
  }

  const [showA, setShowA] = useState(true)
  const toggleShowA = () => setShowA(!showA)

  return (
    <>
      <div className="row">
        {/* message pop up for KYC link begins*/}
        {user.kycStatus !== 'COMPLETED' ? (
          <div className="col-md-12 d-flex justify-content-center">
            <Toast show={showA} onClose={toggleShowA} className="kyc-toast">
              <Toast.Body>
                <h2 className="kyc-toast-title">
                  Your KYC is not completed. Please complete it{' '}
                  <Link to="/kyc">
                    <span className="text-dark kyc-toast-title-link">here</span>{' '}
                  </Link>{' '}
                  in order to be able to buy gold.{' '}
                </h2>
              </Toast.Body>
            </Toast>
          </div>
        ) : (
          <div className="col-md-12 d-flex justify-content-center">
            <Toast show={showA} onClose={toggleShowA} className="kyc-toast">
              <Toast.Body>
                <h2 className="kyc-toast-title">
                  {' '}
                  Click{' '}
                  <a
                    href={`http://rfid.victoreanum.com/?uid=${user._id}`}
                    target="_blank"
                  >
                    here
                  </a>{' '}
                  to buy gold.{' '}
                </h2>
              </Toast.Body>
            </Toast>
          </div>
        )}
        {/* message pop up for KYC link ends*/}


        <div className="col-md-12 d-flex justify-content-between flex-wrap flex-sm-nowrap db_1400">
          <div className="mr-1">
            <h5 className="inpg_ttl mr-5">Get In Touch With The Team</h5>
          </div>
          <button
            type="button"
            className="btn btn-def btn-defv4 btntkt"
            onClick={handleShow}
          >
            Create Ticket
          </button>
          <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
            <form className="subheader_filter">
              <div className="form-row">
                {/* <div className="form-group mr-3 mb-1">
                                    <div className="dtpckr prltv prltv_v2">
                                        <DateTimePicker />
                                        <i className="fas fa-calendar-week"></i>
                                    </div>
                                </div> */}
                <div className="form-group mb-1">
                  <select
                    className="form-control wtblcar_v2"
                    onChange={onStatusChange}
                    value={status}
                  >
                    <option value="">Status </option>
                    <option value="OPEN">OPEN</option>
                    <option value="CLOSED">CLOSED</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-12 mt-5">
          <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
            <TicketTable
              handleShow1={handleShow1}
              ticketList={ticketList}
              limit={limit}
              skip={skip}
              onPageChange={onPageChange}
            />
            {isLoading && (
              <div className="basic-verification-loader">
                <CircularProgress />
              </div>
            )}
          </div>
        </div>
      </div>
      <CreateTicketModal
        OrderDetailsModal={OrderDetailsModal}
        handleClose={handleClose}
        onCreateTicketSubmit={onCreateTicketSubmit}
      />
      <TicketDetailsModal
        openTicketDetailsModal={openTicketDetailsModal}
        handleClose1={handleClose1}
        selectedTicket={selectedTicket}
        onAddComment={onAddComment}
      />
    </>
  )
}

export default SupportTicket
